export const isEmail = (value) => {
  const validEmail = /^[^\s@]+[^.-]@[^.-][^\s@]+\.[^\s@]+$/
  return !validEmail.test(value)
}

export const isEmptyOrWhiteSpace = (str) => {
  const regex = /^\s*$/
  return regex.test(str)
}
